module.exports = __webpack_public_path__ + "img/profile_ev_zf.26dd0b6b.jpeg";